module.exports = __webpack_public_path__ + "ea1b98e5d5d6928acc7f1a636f969467.svg";